import { Box, Container, Stack } from "@mui/material";
import React from "react";
import "../assets/css/Contact.css";
import Grid from "@mui/material/Grid";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

export default function Contact() {
  useDocumentMetaData({
    title: "Contact MidWest Group - Calgary, Alberta",
    description:
      "Get in touch with MidWest Group. Reach us via email at info@midwest1988.com or call 403-277-1551. Visit our head office at 261185 Wagon Wheel Way, Rocky View, AB T4A 0E2.",
    keywords:
      "MidWest Group contact, Calgary construction company, Alberta commercial interiors, contact info, office location, email, phone",
    canonical: "https://www.midwest-group.com/contact/",
    author: "MidWest Group",
    ogTitle: "Contact MidWest Group",
    ogDescription:
      "Reach out to MidWest Group for inquiries or project consultations. Email, phone, and head office address provided for easy communication.",
    ogImage: "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png", // optionally add a relevant office image
    ogUrl: "https://www.midwest-group.com/contact/",
    twitterTitle: "Contact MidWest Group - Calgary, Alberta",
    twitterDescription:
      "Connect with MidWest Group for project inquiries and general information. Email: info@midwest1988.com | Phone: 403-277-1551",
    twitterImage: "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png", // same as OG image or another relevant visual
  });

  return (
    <Container className="contact-container">
      <Box className="contact-box">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
            <Stack alignItems={"start"}>
              <h3 className="contact-info">
                <strong>
                  <span style={{ color: "#5f8c27" }}>Contact</span>
                </strong>
              </h3>
              <div className="seprator"></div>
              <p style={{ marginBottom: "0px", marginTop: "5px" }}>
                <span className="information">
                  <strong>info@midwest1988.com</strong>
                </span>
              </p>
              <p style={{ marginBottom: "0px", marginTop: "5px" }}>
                <span className="information">
                  <strong>403-277-1551</strong>
                </span>
              </p>
              {/* <p style={{ marginBottom: "0px", marginTop: "5px" }}>
                <span className="information">
                  <strong>SK: 306-500-0185</strong>
                </span>
              </p> */}
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
            <Stack alignItems={"start"}>
              <h3 className="contact-info">
                <strong>
                  <span style={{ color: "#5f8c27" }}>Head Office</span>
                </strong>
              </h3>
              <div className="seprator"></div>
              <p
                style={{ marginBottom: "0px", marginTop: "5px" }}
                className="no-wrap"
              >
                <span className="information">
                  <strong>261185 Wagon Wheel Way</strong>
                </span>
              </p>
              <p style={{ marginBottom: "0px", marginTop: "5px" }}>
                <span className="information">
                  <strong>Rocky View, AB T4A 0E2</strong>
                </span>
              </p>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
